import React, { useState, useEffect, useRef } from "react";
import { faChevronLeft, faChevronRight, faPassport, faBriefcase, faGraduationCap, faPlane, faRobot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import img1 from "./images/image1.png";
import img2 from "./images/image2.png";
import img3 from "./images/image3.png";
import custimg1 from "./images/custimage1.png";
import custimg2 from "./images/custimage2.png";
import custimg3 from "./images/custimage3.png";

const WorkBridgeHome = () => {
    const images = [
      { src: img1, caption: "Explore the world" },
      { src: img2, caption: "Find your adventure" },
      { src: img3, caption: "Create memories" },
    ];

    const testimonials = [
        { quote: "WorkBridge made my dream of studying abroad come true! Their AI-driven visa process was smooth.", author: "Satinder Singh, Canada Student Visa", img: custimg1 },
        { quote: "From job counseling to visa approval, everything was seamless. I landed a great job in Australia!", author: "Rahul K., Skilled Worker Visa", img: custimg2 },
        { quote: "I needed urgent visa processing for my corporate team, and WorkBridge delivered beyond expectations.", author: "N. Ramachandran, HR Manager", img: custimg3 },
      ];

      const services = [
        { title: "Visa Processing", desc: "All categories including work, study, business, and tourism visas.", icon: faPassport },
        { title: "Overseas Job Assistance", desc: "Connecting talent with global employment opportunities.", icon: faBriefcase },
        { title: "Skill Training", desc: "Equipping workers with essential skills for overseas employment.", icon: faGraduationCap },
        { title: "Travel & Accommodation", desc: "Hassle-free travel planning and stay solutions.", icon: faPlane },
        { title: "AI-Powered Chatbot", desc: "24x7 instant assistance for visa and immigration queries.", icon: faRobot }
      ];
      
  return (
    <div className="mx-auto">
      <section className="text-center my-2">
        <h2 className="text-xl lg:text-3xl font-bold text-yellow-200">Welcome to WorkBridge Consultancy</h2>
        <p className="text-lg mt-4">
          We are revolutionizing visa processing and global mobility solutions with AI-driven efficiency.
          Our mission is to simplify the complexities of visa applications, overseas employment, travel, and settlement.
        </p>
      </section>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center items-center">
        {images.map((img, idx) => (
          <div key={idx} className="flex justify-center">
            <img src={img.src} alt={img.caption} className="w-full max-w-xs h-auto rounded-lg shadow-lg" />
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-3 gap-6 my-10">
        <div className="p-6 rounded-lg shadow-lg bg-yellow-700 text-black text-center">
          <h3 className="text-lg lg:text-xl font-bold">Our Vision</h3>
          <p className="mt-2">To be the world’s most trusted and technologically advanced visa and immigration service provider.</p>
        </div>
        <div className="p-6 rounded-lg shadow-lg bg-green-700 text-black text-center">
          <h3 className="text-lg lg:text-xl font-bold">Our Mission</h3>
          <p className="mt-2">Simplifying and accelerating visa and immigration processes using AI-driven automation.</p>
        </div>
        <div className="p-6 rounded-lg shadow-lg bg-blue-700 text-white text-center">
          <h3 className="text-lg lg:text-xl font-bold">Our Values</h3>
          <ul className="list-disc pl-5 mt-2">
            <li>Customer-Centric Approach</li>
            <li>Innovation & Technology</li>
            <li>Integrity & Compliance</li>
            <li>Global Reach</li>
            <li>Excellence in Service</li>
          </ul>
        </div>
      </div>

      <section className="my-2 bg-black border border-blue-500 text-center mt-4">
        <h2 className="text-lg lg:text-xl mt-4 font-bold mb-4">Our Services</h2>
        <div className="py-4">
          {services.map((service, index) => (
            <div key={index} className="flex flex-col items-center bg-black text-white">
              <FontAwesomeIcon icon={service.icon} className="text-blue-500 text-xl mb-4" />
              <h3 className="text-xl text-yellow-200 font-bold">{service.title}</h3>
              <p className="text-white mt-2">{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="my-10 text-center">
        <h2 className="text-lg lg:text-xl font-bold">What Our Clients Say</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 place-items-center">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="border p-4 rounded shadow flex flex-col items-center">
              <img src={testimonial.img} alt={testimonial.author} className="w-20 h-20 rounded-full mb-4 shadow-md" />
              <p className="italic">“{testimonial.quote}”</p>
              <span className="block mt-4 font-bold text-gray-700">– {testimonial.author}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="text-center my-10">
        <h2 className="text-3xl font-bold">Contact Us Now</h2>
        <p className="text-lg mt-4">Let us simplify your journey to global opportunities.</p>
        <div className="mt-6 flex flex-row justify-center gap-4">
          <button className="px-6 py-3 text-lg bg-blue-500 text-white rounded flex items-center gap-2">
            🤖 24x7
          </button>
          <button className="px-6 py-3 text-lg bg-green-500 text-white rounded flex items-center gap-2">
            📱 WhatsApp
          </button>
          <button className="px-6 py-3 text-lg bg-purple-500 text-white rounded flex items-center gap-2">
            📞 Phone
          </button>
          <button className="px-6 py-3 text-lg bg-red-500 text-white rounded flex items-center gap-2">
            📧 Email
          </button>
        </div>
      </section>
    </div>
  );
};

export default WorkBridgeHome;
